import React, { useEffect, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import SimpleEditField from "./SimpleEditField";
import { fieldStructure } from "../Helper";
import Icon from "components/Elements/Icon/Icon.tsx";

const FormBuilderEditFieldContainer = ({
  field,
  formItems,
  setFormItems,
  formJson,
  setFormJson,
  setUpdateBeforeSave,
  formLanguage,
  setFormHeight,
  tempField,
  setTempField,
  recipientValidationErrors,
  setRecipientValidationErrors,
}) => {
  const { getTextByKey } = useContent();
  const [selectedOption, setSelectedOption] = useState(
    fieldStructure[field.template].fields.label
  );
  const [openListOptions, setOpenListOptions] = useState(false);
  const [includeOptions, setIncludeOptions] = useState(
    field.template === "selectbasic" ||
      field.template === "multipleradios" ||
      field.template === "multiplecheckboxes"
  );
  useEffect(() => {
    setSelectedOption(fieldStructure[field.template].fields.label);
    setIncludeOptions(
      field.template === "selectbasic" ||
        field.template === "multipleradios" ||
        field.template === "multiplecheckboxes"
    );
  }, [field]);

  const returnTitle = () => {
    if (field && field.template) {
      return fieldStructure[field.template].fields.label;
    } else {
      return "edit-field-title";
    }
  };

  //change field type and update the formJson
  const changeTypeField = (field, newFieldChosen) => {
    //check if field.template is include options
    let includeOptions =
      field.template === "selectbasic" ||
      field.template === "multipleradios" ||
      field.template === "multiplecheckboxes" ||
      field.template === "recipientDropdown";
    if (includeOptions) {
      //covert to new field chosen without change fieldStructure[newFieldChosen]
      let newField = {};
      newField.fields = {};
      //set new field props
      newField.fields.label = field.fields.label;
      newField.template = newFieldChosen;
      newField.fields.helptext = field.fields.helptext;
      newField.fields.required = field.fields.required;
      newField.fields.readonly = field.fields.readonly;
      newField.fields.tempsave = field.fields.tempsave;
      newField.fields.display = field.fields.display;
      newField.fields.downloadname = field.fields.downloadname;
      if (field.template === "textarea") {
        newField.fields.textarea = "";
      }
      newField.id = field.id;
      let oldOptionsType =
        field.template === "selectbasic"
          ? "options"
          : field.template === "multipleradios"
          ? "radios"
          : "checkboxes";
      let newOptionsType =
        newFieldChosen === "selectbasic"
          ? "options"
          : newFieldChosen === "multipleradios"
          ? "radios"
          : "checkboxes";
      if (
        field.fields[oldOptionsType] &&
        field.fields[oldOptionsType].length > 0
      ) {
        //loop through old options and add to new field
        newField.fields[newOptionsType] = [];
        field.fields[oldOptionsType].forEach((option, index) => {
          newField.fields[newOptionsType][index] = option;
        });
      }
      //update formItems
      let newFormItems = formItems.map((item) => {
        if (item.id === field.id) {
          return newField;
        } else {
          return item;
        }
      });
      updateNewOptionField(newFormItems);
    }
  };

  //update database
  const updateNewOptionField = (newFormItems) => {
    setFormItems(newFormItems);
    //update formJson
    let tempFormJson = { ...formJson };
    tempFormJson.items = newFormItems;
    setFormJson(tempFormJson);
    setUpdateBeforeSave({
      mode: true,
      action: "updateJson",
      heightChanged: true,
    });
  };

  const displayEditFieldByType = (field) => {
    if (field) {
      let includeOptions =
        field.template === "selectbasic" ||
        field.template === "multipleradios" ||
        field.template === "multiplecheckboxes";
      return (
        <SimpleEditField
          field={field}
          formItems={formItems}
          setFormItems={setFormItems}
          formJson={formJson}
          setFormJson={setFormJson}
          setUpdateBeforeSave={setUpdateBeforeSave}
          includeOptions={includeOptions}
          formLanguage={formLanguage}
          setFormHeight={setFormHeight}
          tempField={tempField}
          setTempField={setTempField}
          recipientValidationErrors={recipientValidationErrors}
          setRecipientValidationErrors={setRecipientValidationErrors}
        />
      );
    }
  };

  //select field type
  const selectFieldOptions = (selected) => {
    changeTypeField(field, selected);
    setSelectedOption(fieldStructure[selected].fields.label);
    setOpenListOptions(false);
  };

  //Dropdown options list for field type
  const optionsListDropDown = () => {
    const radios = fieldStructure["multipleradios"].fields.label;
    const checkboxes = fieldStructure["multiplecheckboxes"].fields.label;
    const select = fieldStructure["selectbasic"].fields.label;
    //render div with options
    return (
      <div className="form-builder-select-options">
        <div
          className="selected-option"
          onClick={() => setOpenListOptions((prev) => !prev)}
        >
          <div className="selected-option-title">
            <h2>{getTextByKey(selectedOption)}</h2>
          </div>
          <Icon name="arrow-down-solid" small />
        </div>
        <div
          className={`form-builder-options-list ${
            openListOptions ? "open-list" : "close-list"
          }`}
        >
          <div
            className={`form-builder-option ${
              selectedOption === radios ? "selected" : ""
            }`}
            onClick={() => selectFieldOptions("multipleradios")}
          >
            {getTextByKey(radios)}
          </div>
          <div
            className={`form-builder-option ${
              selectedOption === checkboxes ? "selected" : ""
            }`}
            onClick={() => selectFieldOptions("multiplecheckboxes")}
          >
            {getTextByKey(checkboxes)}
          </div>
          <div
            className={`form-builder-option ${
              selectedOption === select ? "selected" : ""
            }`}
            onClick={() => selectFieldOptions("selectbasic")}
          >
            {getTextByKey(select)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="edit-field-container">
      <div className="edit-field-title">
        {includeOptions ? (
          optionsListDropDown()
        ) : (
          <h2>{getTextByKey(returnTitle())}</h2>
        )}
      </div>
      {displayEditFieldByType(field)}
    </div>
  );
};

export default FormBuilderEditFieldContainer;
